import AppointmentButton from '../../appointments/AppointmentButton';
import OrderAgreementProofs from '../../documents/OrderAgreementProofs';
import TentPaymentOptions from "./TentPaymentOptions";

import { useDispatch, useSelector } from "react-redux";

import {
  updateTentSelection
} from "../../../store/checkoutSlice";

const TentProviderCard = ({ provider, eventId, isCheckout, isOrders }) => {

  const dispatch = useDispatch();


  return (
    <div className="card">
      {isOrders && <OrderAgreementProofs serviceType="tentRentals" eventId={eventId} providerId={provider.provider_id} />}
      <AppointmentButton providerId={provider.provider_id || provider.id} providerName={provider.first_name || provider.name} eventId={eventId} source="event-provider" />

      {/* HEADER */}
      <div className="header">
        <h4>
          {provider.first_name} {provider.lastName || ""}
        </h4>

        {isOrders && provider.is_checked_out && (
          <span style={{ color: "green" }}>✔ Checked Out</span>
        )}

        {!isOrders && !provider.is_checked_out && provider.paid_amount === 0 && (
          <button
            onClick={() => {
              if (!window.confirm("Remove provider?")) return;
              dispatch(updateTentSelection({ eventId, percentage: null }))
              console.log("remove tent provider", provider.provider_id);
            }}
          >
            ❌
          </button>
        )}
      </div>

      <TentPaymentOptions
        provider={provider}
        eventId={eventId}
        isCheckout={isCheckout}
        isOrders={isOrders}
      />
    </div>
  );
};

export default TentProviderCard;
